
  import { faAmazon } from '@fortawesome/free-brands-svg-icons';

  export default {
    props: {
      attributes: { type: Object, default () { return {}; } },
      icon: { type: String, default: 'circle-info' },
      prefix: { type: String, default: 'fas' },
      tooltip: { type: String, default: null }
    },
    data () {
      return {
        iconMappings: { search: 'magnifying-glass' }
      };
    },
    computed: {
      computedIcon () {
        if (this.icon === 'amazon') {
          return faAmazon;
        }
        return [this.prefix, this.iconMappings[this.icon] || this.icon];
      },
      tooltipOptions () {
        if (!this.tooltip) {
          return null;
        }
        let opts = { classes: 'listItemTooltip', content: this.tooltip };
        if (!this.$store.getters['utils/isTablet']) {
          opts.trigger = 'click';
        }
        return opts;
      }
    }
  };
